var _path, _path2, _path3, _circle, _circle2, _circle3, _circle4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWithInState(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 14,
    viewBox: "0 0 21 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0139 3.11133H13.0278V11.3752H20.1251V6.36827L17.0139 3.11133Z",
    fill: "#468EE7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.993 3.88867L17.9861 5.88173H14.4861V3.88867H15.993Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0278 0.999999V10.4236C13.0278 10.9759 12.5801 11.4236 12.0278 11.4236H1C0.447715 11.4236 0 10.9759 0 10.4236V1C0 0.447715 0.447716 0 1 0H12.0278C12.5801 0 13.0278 0.447715 13.0278 0.999999Z",
    fill: "#F46767"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.8957,
    cy: 11.4236,
    r: 2.57639,
    fill: "#3D5777"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.9444,
    cy: 11.3749,
    r: 1.16667,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.81247,
    cy: 11.4236,
    r: 2.57639,
    fill: "#3D5777"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.86112,
    cy: 11.3749,
    r: 1.16667,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWithInState);
export default __webpack_public_path__ + "static/media/with_in_state.4ffd484225c0407aeabbe0fd3bcf00d4.svg";
export { ForwardRef as ReactComponent };